<template>
	<div>
		<navTitle><div class="pageTitle">办事处</div></navTitle>
		<div class="officeList">
			<!-- <router-link :to="{name:'office_details'}">
			<office v-for="(item,index) in 10" :key="index"></office>
			</router-link> -->
			<van-list
				v-model="loading"
				:finished="finished"
				:immediate-check="false"
				finished-text="没有更多了"
				@load="onLoad"
				:offset="10"
			>
				<template v-for="item in dataList">
					<router-link :key="item.id" :to="{name:'office_details', query: {id: item.id}}">
						<office :info="item"></office>
					</router-link>
				</template>
			</van-list>
		</div>
		<!-- <div style="position: absolute;left: 50px; top:110px;">666666666666666666666666666666666666666</div> -->
		<!-- <video @canplay="getDuration" ref="testVideo" width="320" height="240" controls x-webkit-airplay="allow" x5-playsinline="" webkit-playsinline="" playsinline="true" >
			<source src="https://www.runoob.com/try/demo_source/movie.mp4" type="video/mp4" />
			您的浏览器不支持 HTML5 video 标签。
		</video> -->
	</div>
</template>

<script>
import navTitle from '@/views/components/navTitle.vue';
import office from '@/views/components/office.vue';
/* eslint-disable */
export default {
	components: {
		navTitle,
		office
	},
	data() {
		return {
			page: 1,
			pageSize: 10,
			loading: false,
      finished: false,
			dataList: []
		};
	},
	created() {
		this.getList()
	},
	mounted() {
		// setTimeout(() => {
		// 	// this.$refs.testVideo.duration
		// 	console.log(this.$refs.testVideo.duration, "this.$refs.testVideo");
		// }, 500)
		// console.log(this.$refs.testVideo.duration, "this.$refs.testVideo");
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '办事处',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		getList() {
			this.$get('api/actile/getWorkList', {
				lat: localStorage.getItem('latitude') || 118.124668,
				lng: localStorage.getItem('longitude') || 24.482005,
				pageSize: 10,
				page: this.page
			}).then(res => {
				this.loading = false;
				let rows = res.data
				if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
				if (this.page == 1) {
					this.dataList = rows
				} else {
					this.dataList = this.dataList.concat(rows);
				}
       
			})
		},
		onLoad() {
			this.page++;
      this.getList();
		},
		getDuration() {
			console.log(this.$refs.testVideo.duration, "getDuration-this.$refs.testVideo");
		}
	}
};
</script>

<style scoped lang="stylus">
.pageTitle
	width 100%
	text-align center
	font-size 34px
	font-weight 500
	color #FFFFFF
.officeList
	padding 22px 30px
</style>
